<div id="outer" class="well container">
    <div class="well-title">
        <div class="col-md-12">Configuration</div>
    </div>
    <div class="col-md-12 well-content">
        <div class="row">
            @for (tile of tiles; track tile) {
                <div class="col-sm-3">
                    <a class="admintile pfblue" [routerLink]="tile.link">
                        <h3 class="title">{{ tile.title }}</h3>
                        <i [ngClass]="tile.icon" style="font-size: 48px; margin: 10px 0; display: block"></i>
                        <p>{{ tile.description }}</p>
                    </a>
                </div>
            }
        </div>
    </div>
</div>
